import { UserTypeEnum } from '@/enums/crm/user-type.enum';
import SettingsModel from '@/models/crm/settings.model';
import UserContactInfo from '@/models/crm/user-contact-info.model';

export abstract class AttendantFilterHelper {
  static isAttendantFilterAvailable(settings: SettingsModel | null, userContactInfo: UserContactInfo | null): boolean {
    if (settings?.loggedUserType !== UserTypeEnum.Normal) {
      return true;
    }
    // Root sem cadastro no CRM chega como Normal, mas o servidor o trata como quem ve tudo.
    if (settings?.restringeVisualizacaoPorHierarquia && settings?.visualizaTudo) {
      return true;
    }
    return Boolean(settings?.restringeVisualizacaoPorHierarquia)
      && (Boolean(userContactInfo?.usuarioDiretorCRM) || Boolean(userContactInfo?.usuarioGestorCRM));
  }
}
